import {useMutation} from '@tanstack/react-query';
import {apiClient, queryClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {toast} from '@common/ui/toast/toast';
import {message} from '@common/i18n/message';
import {showHttpErrorToast} from '@common/utils/http/show-http-error-toast';
import { FileItem } from '../file-item';

interface Response extends BackendResponse {}

export interface CheckListPayload {
  fileItems: Array<FileItem>;
}

interface Payload {
  loan_product_id: number;
  meta_header: string;
  files: any;
}

export function useLoanProgramAction(loan_product_id: number, meta_header: string, files: any) {
  return useMutation({
    mutationFn: ({loan_product_id}: Payload) =>
      executeLoanProgramAction({loan_product_id: loan_product_id, meta_header: meta_header, files: files}),
      onSuccess: (response: any, payload) => {
      if (response.message) {
        toast(
          message(response.message),
        );
      } else {
        toast(
          message(`You has just uploaded loan program.`),
        );
      }
      
      // queryClient.invalidateQueries({queryKey: DatatableDataQueryKey(`market-rates/${id}`)});
    },
    onError: err => showHttpErrorToast(err),
  });
}

function executeLoanProgramAction({
  loan_product_id, meta_header, files
}: Payload): Promise<Response> {
  return apiClient
    .post(`loan-products/${loan_product_id}/loan-program-add`, FilePayloadToFormData({meta_header: meta_header, files: files}), {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(r => r.data);
}

export function FilePayloadToFormData(
payload: Partial<Payload>,
) {
  const formData = new FormData();
  if (payload.meta_header) {
    formData.append("meta_header", payload.meta_header);
  }
  if (payload.files) {
      if (payload.files) {
        // payload.files.forEach((file: any) => {
        formData.append("files", payload.files);
        // });
      }
  }

  return formData;
}

